var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:[
	'button-'+_vm.type,
	_vm.size?'button-'+_vm.size:'',
	{
		'btn-disabled':_vm.disabled,
		'btn-loading':_vm.loading,

	}
],on:{"click":_vm.handleClick}},[(_vm.loading)?_c('i',{staticClass:"iconfont icon-loading",on:{"click":_vm.stopClick}}):_vm._e(),_vm._v(" "),_c('span',{on:{"click":_vm.stopClick}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-5b38b995","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/button/src/button.vue
// module id = NyVH
// module chunks = 11